module.exports = __webpack_public_path__ + "img/customer-service.00888c40.png";